<template>
	<div class="l-body">
	<Top/>
	<div class="wrap" :class="bgId">
	  <div class="l-wrap zheng">
	    <div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">封号查询</span></div>
	    <div class="help-menu-box">
	      <div class="st_trees">
	        <ul class="tree_a">
	          <li><a>封号查询</a></li>
	        </ul>
	      </div>
	    </div>
		<div class="sp tcs1" v-show="show">
		        <div class="spinners bs03">
		            <i id="colose" @click="cl"></i>
					<div class="tc_zhengwen">
					<h1 class="tcbiaoti">查询到以下信息</h1>
					<div class="tczwtxt tczwt2" v-for="data in tData">
					<li><p><b>服务器名称：</b>{{data.servename}}</p></li>
					<li><p><b>角色名称：</b>{{data.username}}</p></li>
					<li><p><font color="#FF0000"><b>封号时间：</b>{{data.time}}</font></p></li>
					<li><p><b>封号原因：</b></p></li>
					<li><p>{{data.reason}}</p></li>
					<li><p><b>其他说明：</b></p></li>
					<li><p>{{data.other}}</p></li>
					<li class="tcanniu" style="cursor:pointer"><a @click="down" v-if="page>1">上一页</a><a @click="up" v-if="page<upage">下一页</a></li>
					</div>
					</div>
		        </div>
		    </div>
		  <div class="help-jl-box">
		  <h1>当前正在进行封号查询</h1>
		  <div class="xiangxi">
			  <table class="biaogea">
			  <tr>
			  <th width="23%">请选择服务器（区）：</th>
			  <td width="77%"><div>
			  <el-select v-model=choose style="width:320px">
			      <el-option v-for='item in gameData' :label="item.info" :value="item.info" :key="item.info"></el-option>
			  </el-select>
			  </div></td>
			  </tr>
			  <tr>
			  <th></th>
			  <td class="anniua"><a @click="shou" style="text-align: center;">提交</a></td>
			  </tr>
			  </table>
		  </div>
		    <div class="hujiao">
		      <p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
		      <p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
		    </div>
		  </div>
	  </div>
	</div>
	</div>
</template>

<script>
import Top from '@/components/top.vue'
  export default {
    name: "complain",
    components: {
      Top
    },
	data () {
	  return {
	    id:this.$route.query.id,
	    game:this.$route.query.name,
	    bgId:'',
		choose:'',
		gameData:[],
		show:false,
		tData:[],
		tData1:[],
		page:0,
		upage:0
	  }
	},
	created() {
	  this.gameBg()
	  this.getgameQ()
	},
	methods:{
	  gameBg(){
	    if(this.id==1){
	      this.bgId='sun'
	    }else if(this.id==2){
	      this.bgId='mu'
	    }else if(this.id==4){
	      this.bgId='ro'
	    }else if(this.id==5){
	      this.bgId='moli'
	    }else if(this.id==3){
	      this.bgId='mu2'
	    }
	  },
	  getgameQ(){
	  		this.$axios({
	  		  method: 'get',
	  		  url: '/index.php/user/User/gameinfo',
	  		  params: {
	  			id:this.id,
	  		  }
	  		}).then(res => {
	  		  if(res.data.status==200){
	  			this.gameData=res.data.data
	  		  }else{
	  			this.gameData=[]
	  		  }
	  		})
	  },
	  cl(){
		this.show=false
	  },
	  up(){
		var p=this.page
		var p2=p+1
		this.tData=this.tData1.slice(p,p2)
		this.page=this.page+1
	  },
	  down(){
		var p=this.page
		var p1=p-1
		var p2=p-2
		this.tData=this.tData1.slice(p2,p1)
		this.page=this.page-1
	  },
	  shou(){
		if(this.choose==''){
			this.$message({
				type: 'error',
				message:'服务器必须选择',
				offset:300
			});
			return false;
		}
		this.$axios({
		  method: 'get',
		  url: '/index.php/user/User/userfind',
		  params: {
			gamename:this.game,
			servename:this.choose
		  }
		}).then(res => {
		  console.log(res.data)
		  if(res.data.status==200){
			this.page=1
			this.upage=res.data.data.length
			this.tData1=res.data.data
			this.tData=res.data.data.slice(0,1)
			this.show=true
		  }else{
			this.$alert('没有相关封号信息！', {
				confirmButtonText: '确定',
			});
		  }
		}) 
	  }
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/complain.vue